// extracted by mini-css-extract-plugin
module.exports = {"datesBar":"LastSyncDataBar_datesBar__1ScZk","title":"LastSyncDataBar_title__1-zzc"};